import React, { Component } from "react";
import "./App.css";
import Map from "./views/Map.js";
import "babel-polyfill";

import {
  withStyles,
  createMuiTheme,
  MuiThemeProvider,
} from "@material-ui/core/styles";

import { database } from "./firebase";

import { Grid } from "@material-ui/core";
import RacerDetailView from "./views/RacerDetailView";
import MainAppBar from "./views/MainAppBar";

const theme = createMuiTheme({
  palette: {
    type: "light",
    primary: { main: "#ffffff" },
  },
});

const styles = (theme) => ({
  root: {
    height: "100%",
    display: 'flex',
    flexFlow: 'column',
    maxHeight: '100vh'

  },
  container: {
    
  },
  fake: {
    overflow: 'scroll',
    height: '100%'
  
  },
  header: {
    maxHeight: '64px',
    width: "100%",
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto',
  },
  telemetry: {},
  fullHeightContainer: {
    // height: '100%',
    // width: '100%'
  },
  contentContainer: {
    display: 'flex',
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 'auto',
    height: 'calc(100% - 64px)'
  },
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      racers: {},
      mapBounds: [0, 0, 0, 0],
    };
    this.ref = database.ref("telemetry");
    this.mapDomRef = React.createRef();
  }

  componentDidMount() {}

  handleRacerAdd = (prevState, data) => {
    let stateCopy = Object.assign({}, prevState);
    stateCopy.racers[data.key] = data.val();
    return { stateCopy };
  };

  handleRacerRemove = (prevState, data) => {
    let stateCopy = Object.assign({}, prevState);
    delete stateCopy.racers[data.key];
    return { stateCopy };
  };

  componentWillUnmount() {}

  boundsToCenter(bounds) {}

  boundsToRadius(bounds) {}

  showTelemetry = (id) => {
    this.setState({
      telemetryId: id,
    });
  };

  /*
  <Grid container direction={'row'}  className={classes.fullHeightContainer}>

              <Grid item md xs={12}  className={classes.fullHeightContainer}>

                <Map
                  className={classes.fullHeightContainer}
                  onRacerChoice={this.showTelemetry}
                  onBoundsChanged={this.onBoundsChanged}
                  racers={this.state.racers}
                />

              </Grid>




            </Grid>

            
   */

   /**/

  handleTelemetryClose = () => {
    this.setState({
      telemetryId: undefined,
    });
  };

  render() {
    const { classes } = this.props;
    const queryParameters = new URLSearchParams(window.location.search)
    const hideAppBar = queryParameters.get("hide_app_bar")
    console.log(hideAppBar);
    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root}>
          {
            hideAppBar !== 'true'  && <MainAppBar
            className={classes.header}
            handleTelemetryClose={this.handleTelemetryClose}
            isTelemetryOpen={this.state.telemetryId !== undefined}
          />
          }
          
          <Grid
            direction={"row"}
            container
            item
            className={classes.contentContainer}
          >
            <Grid item xs>
              <Map
                className={classes.fullHeightContainer}
                onRacerChoice={this.showTelemetry}
                onBoundsChanged={this.onBoundsChanged}
                racers={this.state.racers}
              />
            </Grid>

            {this.state.telemetryId !== undefined && (
              <Grid item xl={2} md={3} sm={4} xs={6} className={classes.fake} container>
                <Grid item xs>
                <RacerDetailView id={this.state.telemetryId} close={() => this.handleTelemetryClose()} />
                </Grid>
              </Grid>
            )}
          </Grid>
        
        </div>
      </MuiThemeProvider>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js